import React from 'react';
import { Typography, theme } from 'antd';

const { Text } = Typography;

export interface AppBrandProps {
  /** Hide the wordmark (collapsed sider). */
  collapsed?: boolean;
  size?: 'sm' | 'md';
}

/**
 * Shared mark + wordmark for login, sider, and mobile header.
 * Mark is a token-colored tile so it tracks ConfigProvider, not a raster logo.
 */
const AppBrand: React.FC<AppBrandProps> = ({ collapsed = false, size = 'sm' }) => {
  const { token } = theme.useToken();
  const mark = size === 'md' ? 40 : 28;

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: token.marginSM,
        minWidth: 0,
      }}
    >
      <span
        aria-hidden
        style={{
          width: mark,
          height: mark,
          borderRadius: token.borderRadius,
          background: token.colorPrimary,
          color: token.colorTextLightSolid,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 600,
          fontSize: Math.round(mark * 0.42),
          letterSpacing: '-0.04em',
          flexShrink: 0,
          lineHeight: 1,
        }}
      >
        H
      </span>
      {!collapsed && (
        <span
          style={{
            display: 'flex',
            flexDirection: 'column',
            minWidth: 0,
            textAlign: 'left',
            lineHeight: 1.2,
          }}
        >
          <Text
            strong
            ellipsis
            style={{
              fontSize: size === 'md' ? token.fontSizeHeading4 : token.fontSizeLG,
              color: token.colorText,
            }}
          >
            Identity
          </Text>
          {size === 'md' && (
            <Text type="secondary" style={{ fontSize: token.fontSizeSM }}>
              HABBY 员工账号
            </Text>
          )}
        </span>
      )}
    </span>
  );
};

export default AppBrand;
